import { make } from 'vuex-pathify'
import { getQueryFromFilter, showError } from '@/util/helpers'
import axios from 'axios'

const state = {
  activity: {},
  activities: {
    data: [],
    count: 0,
    limit: 50,
  },

  filter: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ['timestamp'],
    sortDesc: [false],
  },

  loading: false,
}

const mutations = make.mutations(state)

const actions = {
  save: ({ state }, activity) => {
    const id = activity.id
    const method = id ? 'put' : 'post'

    state.loading = true
    return axios[method](`${process.env.VUE_APP_API_URL}/activity/${id || ''}`, activity)
      .then((res) => {
        return res.data.id || activity.id
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  get: async ({ state }, filter = state.filter) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/activity?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.activities = res.data

        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
